export default {
      id: "oc-ctyun-usage",
      viewBox: "0 0 1123 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-ctyun",
      toString: function () {
        return this.url;
      }
    }